<template>
  <div class="animated fadeIn step-container">
  
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h2 v-if="$route.query.action === 'edit'">{{$t('message.doctor_header.title_edit')}}</h2>
        <h2 v-else>{{$t('message.doctor_header.title_new')}}</h2>
        <step :currentStep="2" :maxStep="5" @step_clicked='gotoPage'>
          <div slot='1'>{{$t('message.doctor_header.personal_info')}}</div>
          <div slot='2'>{{$t('message.doctor_header.experience')}}</div>
          <div slot='3'>{{$t('message.doctor_header.schedules')}}</div>
          <div slot='4'>{{$t('message.doctor_header.education')}}</div>
          <div slot='5'>{{$t('message.doctor_header.other_info')}}</div>
        </step>
      </div>

      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">{{$t('message.doctor_header.experience')}}</h4>

        <div class="row">
          <div class="col-12">
            <h6>{{$t('message.doctor_experience.specialty')}}</h6>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label for="name">สาขาเฉพาะทาง</label>
              <multiselect id="speciality" 
                    class="multi-select-form"
                    v-model="selected_specialities" 
                    :placeholder="$t('message.doctor_experience.specialty_placeholder')" 
                    :options="select_specialties_options" 
                    :allow-empty="false" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
            </div>
          </div>

          <div class="col-12">

            <div class="form-group">
              <label for="name">{{$t('message.doctor_experience.subspecialty')}}</label>
              <multiselect id="subspeciality" 
                    class="multi-select-form"
                    v-model="selected_sub_specialities" 
                    :placeholder="$t('message.doctor_experience.subspecialty_placeholder')" 
                    :options="sub_specialities" 
                    :multiple="true"
                    :hide-selected="true"
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <bs-input :label="$t('message.doctor_experience.medical_procedure_th')" v-model="doctor.th.custom_text" :placeholder="$t('message.doctor_experience.medical_procedure_placeholder')" :maxlength="120"></bs-input>
            </div>
          </div>
          
          <div class="col-12">
            <div class="form-group">
              <bs-input :label="$t('message.doctor_experience.medical_procedure_en')" v-model="doctor.en.custom_text" :placeholder="$t('message.doctor_experience.medical_procedure_placeholder')" :maxlength="120"></bs-input>
            </div>
          </div>

        </div>

        <div class="form-divider"></div>

        <div class="row">

          <div class="col-12">
            <h6>{{$t('message.doctor_experience.place')}}</h6>
          </div>

          <div class="col-12">

            <div class="form-group">
              <label for="name">{{$t('message.doctor_experience.clinic_place')}}</label>
              <multiselect id="clinic" 
                    class="multi-select-form"
                    v-model="selected_clinics" 
                    :placeholder="$t('message.doctor_experience.clinic_place_placeholder')" 
                    :options="clinics" 
                    :multiple="true"
                    :hide-selected="true"
                    :allow-empty="true" 
                    :disabled="$guser.isClinic() || $guser.isClinicMulti()"
                    :loading="clinicLoading"
                    @search-change="getClinicsOptions"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
            </div>

            <div class="form-group">
              <label for="name">{{$t('message.doctor_experience.institute_place')}}</label>
              <multiselect id="institute" 
                    class="multi-select-form"
                    v-model="selected_institute" 
                    :placeholder="$t('message.doctor_experience.institute_place_placeholder')" 
                    :options="select_institutes_options" 
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
            </div>
          </div>
          
        </div>

        <div class="row">
          <div class="col-12 form-group">
            <button class="btn btn-cancel btn-lg" @click="back">{{$t('action_message.back')}}</button>
            <button class="btn btn-store btn-lg" @click="saveAndContinue">{{$t('action_message.save')}}</button>
            <button v-if="$route.query.action === 'edit'" class="btn btn-delete btn-right btn-lg" @click="deleteDoctor">{{$t('action_message.remove')}}</button>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Step from '@/components/StepBar'
import { input as BsInput } from 'vue-strap'
import Dropzone from 'vue2-dropzone'
import Multiselect from 'vue-multiselect'
import router from '@/router'
import DoctorMixin from './mixin'

export default {
  name: 'DoctorEditStep1',
  mixins: [DoctorMixin],
  components: {
    BsInput,
    Step,
    Dropzone,
    Multiselect
  },
  data () {
    return {
      doctor: {
        en: {
          custom_text: null
        },
        th: {
          custom_text: null
        }
      },
      selected_specialities: null,
      selected_sub_specialities: [],
      specialities: [],
      sub_specialities: [],
      institutes: [],
      selected_institute: null,
      clinics: [],
      selected_clinics: [],
      selected_clinic: null,
      clinicLoading: false
    }
  },
  computed: {
    select_specialties_options () {
      return this.specialities.map(function (s) {
        return { label: s.name, value: s.id }
      })
    },
    _selected_specialties () {
      try {
        let self = this
        return this.doctor.specialities.map(function (s) {
          if (self.$i18n.locale === 'en') {
            return { label: s.name_en, value: s.id }
          }
          return { label: s.name_th, value: s.id }
        })
      } catch (e) {
        return null
      }
    },
    select_institutes_options () {
      return this.institutes.map(function (s) {
        return { label: s.name, value: s.id }
      })
    }
  },
  watch: {
    selected_specialities (newValue) {
      // update sub specialities
      var spid = +newValue.value
      var self = this
      this.$http.get(this.$APP_CONFIG.api.sub_specialities(spid)).then(res => {
        self.sub_specialities = res.body.map(function (s) {
          return { value: s.id, label: s.name }
        })
      })
    }
  },
  methods: {
    back () {
      router.go(-1)
    },
    selectSpeciality (values) {
      var self = this
      // updated select in doctor;
      this.doctor.specialities = values.map(function (v) {
        var s = self.specialities.find(_s => +_s.id === +v.value)
        return {
          id: s.id,
          name_th: s.translations.find(t => t.locale === 'th').name,
          name_en: s.translations.find(t => t.locale === 'en').name
        }
      })
    },
    saveAndContinue () {
      let data = {
        en: {
          custom_text: this.doctor.en.custom_text
        },
        th: {
          custom_text: this.doctor.th.custom_text
        }
      }
      if (this.selected_specialities) {
        data.specialities = [+this.selected_specialities.value]
      }

      if (this.selected_sub_specialities) {
        data.subspecialities = this.selected_sub_specialities.map(s => +s.value)
      }

      if (this.selected_institute) {
        data.institutes = [+this.selected_institute.value]
      }

      if (this.selected_clinics) {
        data.clinics = this.selected_clinics.map(c => +c.value)
      }

      let routeData = { path: this.next_uri(2), query: {action: this.$route.query.action} }
      this.$http.put(this.doctor_uri,
        // data
        data,
        // options
        {
          credentials: true,
          headers: { 'content-type': 'application/json' }
        }).then(res => {
          if (res.body.status === 'success') {
            this.$toastr.success(this.$t('action_message.save_success'))
            router.push(routeData)
          }
        })
    },
    getClinicsOptions (search) {
      var self = this
      self.clinicLoading = true
      this.$http.get(this.$APP_CONFIG.api.clinics(), {
        params: {
          clinic_name: search
        },
        credentials: true
      }).then(resp => {
        self.clinics = resp.body.data.map(function (c) {
          return {
            value: c.id,
            label: c.clinic_name
          }
        })
        self.clinicLoading = false
      })
    },
    async deleteDoctor () {
      if (await this.$confirm(this.$t('action_message.are_you_sure'))) {
        this.$http.delete(this.$APP_CONFIG.api.admin.doctors_id(this.doctor.id)).then(res => {
          if (res.body) {
            router.push({path: '/clinic/doctors'})
          }
        })
      }
    }
  },
  created () {
    var self = this

    // fetch spcialties
    this.$http.get(this.$APP_CONFIG.api.specialties(), { credentials: true }).then(res => {
      self.specialities = res.body
    })

    // fetch institutes
    this.$http.get(this.$APP_CONFIG.api.institutes(), { credentials: true }).then(res => {
      self.institutes = res.body
    })

    /* if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
      this.$http.get(this.$APP_CONFIG.api.admin.clinicme(), { credentials: true }).then(res => {
        self.clinics = [
          {
            value: res.body.data.id,
            label: res.body.data.en.clinic_name
          }
        ]
        self.selected_clinic = res.body.data.id
      }, errorResponse => {
        console.error(errorResponse)
      })
    } */

    this.$http.get(this.doctor_uri, { credentials: true }).then(res => {
      self.doctor = Object.assign({}, self.doctor, res.body.data)
      // update selected specialities
      if (self.doctor.specialities.length > 0) {
        var s = self.doctor.specialities[0]
        if (self.$i18n.locale === 'en') {
          self.selected_specialities = { value: s.id, label: s.name_en }
        } else {
          self.selected_specialities = { value: s.id, label: s.name_th }
        }
      }
      // update selected sub specialities
      self.selected_sub_specialities = this.doctor.subspecialities.map(s => {
        if (self.$i18n.locale === 'en') {
          return { value: s.id, label: s.name_en }
        } else {
          return { value: s.id, label: s.name_th }
        }
      })

      // update selected institute
      if (self.doctor.institutes.length > 0) {
        var ins = self.doctor.institutes[0]
        if (self.$i18n.locale === 'en') {
          self.selected_institute = { value: ins.id, label: ins.name_en }
        } else {
          self.selected_institute = { value: ins.id, label: ins.name_th }
        }
      }

      // update selected clinics
      self.selected_clinics = this.doctor.clinics.map(c => { return { value: c.id, label: c.name_th } })
    }, errorResponse => {
      console.error(errorResponse)
    })
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import "../../../assets/base_container";
.step-header {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.step-container{
  h6{
    color: #5e5e5e;
    margin-bottom: 12px;
    font-size: 1.2rem;
  }
  .step-body{
    background-color: #fff;
    padding-top: 10px;
  }
}
.form-divider{
  height: 1px;
  border: 1px dashed #eee;
  margin: 10px 0;
}
.gender-select{
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: 1rem;
  .form-check{
    margin-bottom: 0px;
  }
  .form-check-inline + .form-check-inline{
    margin-left: 2.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// Experience.vue?753e1a70